import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHandshake,
  faGlobe,
  faShieldAlt,
  faUsers,
  faChartLine,
  faBriefcase,
} from "@fortawesome/free-solid-svg-icons";
import "../Styles/WhyChooseUs.css";

function WhyChooseUs() {
  const features = [
    {
      icon: faHandshake,
      title: "Professional and Responsive Communication",
      description:
        "We believe every hiring engagement should be managed with clarity, professionalism, and timely communication, creating a smoother experience for clients at every stage.",
    },
    {
      icon: faChartLine,
      title: "Industry-Aware Recruitment Support",
      description:
        "Our work is shaped by the practical demands of different industries, allowing us to support hiring with greater relevance and alignment.",
    },
    {
      icon: faShieldAlt,
      title: "Confidential and Structured Delivery",
      description:
        "We handle hiring requirements with discretion and discipline, especially where confidentiality and professionalism are essential.",
    },
    {
      icon: faGlobe,
      title: "Access to a Global Team of Professional Recruiters",
      description:
        "Workforce Nexus benefits from a global team of professional recruiters, enabling broader reach, stronger market coverage, and faster support.",
    },
    {
      icon: faUsers,
      title: "Built for Long-Term Value",
      description:
        "We focus on building lasting business relationships through consistency, service quality, and a practical understanding of recruitment outcomes.",
    },
    {
      icon: faBriefcase,
      title: "Business-Focused Hiring Solutions",
      description:
        "Our recruitment support is designed to strengthen business growth by connecting organizations with dependable talent strategies that improve workforce performance and hiring efficiency.",
    },
  ];

  return (
    <section className="why-section" id="whychooseus">
      <div className="why-header">
        <h2 className="why-title">
          <span>Why Choose Workforce Nexus</span>
        </h2>

        <p className="why-description">
          Businesses choose Workforce Nexus for a recruitment approach that blends professionalism, adaptability, and reliable execution. We provide tailored staffing solutions designed to meet unique business needs while building trust through transparency and consistent results. With clear differentiation, industry expertise, and a commitment to quality talent acquisition, Workforce Nexus stands as a dependable partner in driving workforce success and long-term business growth.
        </p>
      </div>

      <div className="why-cards-container">
        {features.map((feature, index) => (
          <div className="why-card" key={index}>
            <div className="why-icon-box">
              <FontAwesomeIcon icon={feature.icon} />
            </div>

            <h3>{feature.title}</h3>

            <p>{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default WhyChooseUs;